/**
 * Toggle the active class on the hamburger
 * Set navigation and navigationActive strings to your used classes
 */
export const initNavigation = function(md) {
  let hamburger = $('.hamburger');
  let navigation = $('.mobile-menu');
  let navigationActive = 'mobile-menu--active';
  let screenMask = $('.screen-mask');

  hamburger.on('click', () => {
    hamburger.toggleClass('open');
    navigation.toggleClass(navigationActive);
    screenMask.toggleClass('screen-mask--active');
    $('body').toggleClass('navigation-active');
  });

  screenMask.on('click', () => {
    hamburger.toggleClass('open');
    navigation.toggleClass(navigationActive);
    screenMask.toggleClass('screen-mask--active');
    $('body').toggleClass('navigation-active');
  });

  if ( md.phone() || md.tablet() ) {

    $('.mobile-menu__item--has-children .mobile-menu__item-link').on('click',function(e){
      e.preventDefault();
      $(this).parent().toggleClass('mobile-menu__item--active');
    });

    $('.mobile-menu__sub-item--has-children .mobile-menu__sub-item-link').on('click',function(e){
      e.preventDefault();
      $(this).parent().toggleClass('mobile-menu__sub-item--active');
    });



  }


};